import type { Bootstrap } from '@/data/user/bootstrap-data/interfaces';
import type { Features } from '@/models/bootstrap/plan';
import type { Permissions, User } from '@/models/user';
import type { BootstrapContext } from '@/routes/protected-route/interfaces';

export interface AccessRules {
  permissions?: Permissions | Permissions[];
  features?: Features | Features[];
  check?: (ctx: BootstrapContext) => boolean;
}

const hasPermission = (user: User, perm: Permissions) => {
  return user?.permissoes?.some((p) => p.nome === perm) ?? false;
};

export const hasFeature = (plan: Bootstrap['plan'], feature: Features) => {
  return plan?.features?.some((f) => f?.name === feature) ?? false;
};

export const hasAccess = (
  ctx: BootstrapContext,
  rules: AccessRules
): boolean => {
  const { user, bootstrap } = ctx;
  const { permissions, features, check } = rules;

  if (permissions && user) {
    const perms = Array.isArray(permissions) ? permissions : [permissions];
    if (!perms.every((perm) => hasPermission(user, perm))) return false;
  }

  if (features && bootstrap?.plan) {
    const feats = Array.isArray(features) ? features : [features];
    if (!feats.every((feat) => hasFeature(bootstrap?.plan, feat))) return false;
  }

  if (check && !check(ctx)) return false;

  return true;
};
